import React from 'react';
import { connect } from "react-redux";
import createItem from '../../../../API/Provider/CreateExchangeRate.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from '../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import './datepicker.scss'
import hr from 'date-fns/locale/hr';
import GetAutomatic from './../../../../API/Provider/GetAutomatic'
import Select from 'react-select'
import { Col, Form, Row, Button } from 'react-bootstrap';

class CreateTecajnaLista extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        date_of_exchange_rate: new Date(),
        currency_name: "",
        currency_short: "",
        exchange_rate:  0,
        automaticList: [],
        automaticPicked: {},
        automatic: false
    }

    componentDidMount = async () => {
        document.title = this.props.t("Exchange rate") + "-" + this.props.t("Create")

        await this.setState({
            automaticList: [],
            automaticPicked: {}
        })
        //get countries
        let items = await GetAutomatic()       
        let list = []

        await items.data.map((data, index) =>{
            let oneItem = {value: index , label: data }
            list.push(oneItem)
            return null
        })

        await this.setState({
            loading: false ,
            automaticList: list,
            automaticPicked: list[0]           
        })
    }

    handleDateChange(date){
       this.setState({ date_of_exchange_rate: date})
    }

    handleChange(e){
        let value = e.target.value
        this.setState({
            [e.target.id]: value === "on" ? !this.state[e.target.id] : value
        })  
    }

    handleAutomaticListChange(e){ 
             
        this.setState({
            automaticPicked: e
        })                  
    }

    submitCreate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let create = await createItem(
            this.state
        )

        if(create.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: "Creating was successful",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('There was an error creating the client type, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
    }

    render(){  
        const { t } = this.props
        
        console.log(this.props)
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="country" column sm={2} md={4}>{t('Date')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <DatePicker
                                        selected={this.state.date_of_exchange_rate}
                                        onChange={date => this.handleDateChange(date)}
                                        //selectsStart
                                        startDate={new Date()}
                                        //endDate={this.props.endDate}
                                        locale={this.props.lng === "hr" ? hr : null}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}
                                        className="date-picker"
                                    />                                 
                                </Col>
                            </Form.Group>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="currency_name" column sm={2} md={4}>{t('Name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control        
                                        id="currency_name"                          
                                        type="text"
                                        value={this.state.currency_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="currency_short" column sm={2} md={4}>{t('Short')}</Form.Label>
                                <Col sm={10} md={8}>
                                    { !this.state.automatic ? 
                                       <Form.Control        
                                            id="currency_short"                          
                                            type="text"
                                            value={this.state.currency_short}
                                            onChange={e => this.handleChange(e)}
                                        />   
                                    :
                                        <Select
                                            options={this.state.automaticList} 
                                            onChange={(values) => this.handleAutomaticListChange(values)}
                                            isInvalid={this.state.automaticPicked === null}
                                            value={this.state.automaticPicked}
                                        />    
                                    }
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="exchange_rate" column sm={2} md={4}>{t('Exchange Rate')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                        id="exchange_rate"                          
                                        type="number"
                                        value={this.state.exchange_rate}
                                        onChange={e => this.handleChange(e)}
                                        min={0}
                                    />   
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="automatic" column sm={2} md={4}>{t('PDV')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Label className="checbox-form-label" htmlFor="gridCheck2">
                                       <input    
                                            id="automatic"                       
                                            type="checkbox"
                                            checked={this.state.automatic}
                                            onChange={e => this.handleChange(e)}
                                        />
                                        
                                        &nbsp;&nbsp; {t('automatic')}
                                    </Form.Label>
                                </Col>
                            </Form.Group>

                            <Row className="form-group row">
                                <Col sm={12} className="text-center">                                
                                    <Button                                     
                                        className="btnSpremi"                                     
                                        onClick={(e) => this.submitCreate(e)}
                                    >
                                        {t('Save')}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row className="back-button-container">
                        <Button
                            variant='default'
                            className="btn-default mt-2 mb-2"
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        </Button>
                    </Row>
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateTecajnaLista));


